import type { ReactElement } from 'react'
import { useT } from '../i18n/useI18n'
import './ServiceNotice.css'

interface Props {
  className?: string
}

export default function ServiceNotice({ className }: Props): ReactElement {
  const t = useT()
  return (
    <aside className={className ? `sm-service ${className}` : 'sm-service'}>
      <span className="sm-service-icon" aria-hidden="true"><i className="bi bi-cpu" /></span>
      <div className="sm-service-text">
        <h2 className="sm-service-title">{t('service.title')}</h2>
        <p className="sm-service-body">{t('service.body')}</p>
      </div>
    </aside>
  )
}
